import React, {ReactNode, useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {actionCreators} from '../../../store/userSettings/userSettingsActions';
import {ApplicationState} from '../../../store';

interface Props {
  children: ReactNode;
}

export default function GlobalHeader(props: Props) {
  const {children} = props;
  const Children = children;

  const dispatch = useAppDispatch();

  let userSettingsState = useAppSelector(
    (state: ApplicationState) => state.UserSettings,
  );
  const acepID = userSettingsState.acepID;
  const ssoUser = userSettingsState.ssoUser;

  useEffect(() => {
    dispatch(actionCreators.setJWTTokenGlobalHeader());
  }, []);

  useEffect(() => {
    if (acepID !== null) {
      dispatch(actionCreators.getUserSettingslByACEPID(acepID));
    }
  }, [acepID]);

  return (
    <acep-master env={'prod'} title="Point-Of-Care Tools" ssouser={ssoUser}>
      <div slot="bodySlot">{Children}</div>
    </acep-master>
  );
}
